import * as React from 'react'

import { Box, Button, InputCheckBox, Text } from '@factorialco/deprecated-design-system'
import { AtsRejectionReasonItemFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteRejectionReason } from 'modules/ats/hooks/rejectionReasons/useDeleteRejectionReason'

interface Props {
  rejectionReason: AtsRejectionReasonItemFragment
  onClose: () => void
}

export const DeleteRejectionReasonModal = ({ rejectionReason, onClose }: Props) => {
  const { deleteRejectionReason } = useDeleteRejectionReason(rejectionReason)
  const [checked, setChecked] = React.useState(false)

  const onDelete = async () => {
    const result = handleResult(await deleteRejectionReason(), () => {})
    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('ats.rejection_reasons.settings.delete_reason.success_deleted_message'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.rejection_reasons.settings.delete_reason.failed_deleted_message'),
      })
    }
    onClose()
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t('ats.rejection_reasons.settings.delete_reason.title')}
      description={i18n.t('ats.rejection_reasons.settings.delete_reason.description')}
      onSubmit={onDelete}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={!checked} submit>
            {i18n.t('ats.rejection_reasons.settings.delete_reason.submit')}
          </Button>
        </>
      }
    >
      <Box flexDirection="row" gap="s8" alignItems="center">
        <InputCheckBox checked={checked} onClick={() => setChecked(!checked)} />
        <Text.Normal>
          {i18n.t('ats.rejection_reasons.settings.delete_reason.confirmation')}
        </Text.Normal>
      </Box>
    </Modal>
  )
}
